import { render, staticRenderFns } from "./StatisticsFeedback.vue?vue&type=template&id=000070f0&"
import script from "./StatisticsFeedback.vue?vue&type=script&lang=js&"
export * from "./StatisticsFeedback.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports